/* eslint-disable */
import _ from 'lodash';

const editStringCase = (obj, stringCase = 'snakeCase') => {
  if (typeof obj != 'object') return obj;

  for (let oldName in obj) {
    let newName = _[stringCase](oldName);

    if (newName != oldName) {
      if (obj.hasOwnProperty(oldName)) {
        obj[newName] = obj[oldName];
        delete obj[oldName];
      }
    }
    try {
      if (typeof obj[newName] == 'object') {
        obj[newName] = editStringCase(obj[newName], stringCase);
      }
    } catch {}
  }
  return obj;
};

export default editStringCase;
